import {
  Divider, Icon, Popup, Segment, Table,
} from '@mairistem/composants';
import React from 'react';

interface NatureJuridiqueCatPesItemProps {
  categorie: string;
  natureJuridique: string;
  keyNatureJuridique: string;
  activeCell: boolean;
  onClick: (categorie: string, natureJuridique: string) => void;
  onDoubleClick: VoidFunction;
}

const NatureJuridiqueCatPesItem = ({
  categorie,
  natureJuridique,
  keyNatureJuridique,
  activeCell,
  onClick,
  onDoubleClick,
}: NatureJuridiqueCatPesItemProps) => {
  const popupContent = (
    <Segment color="blue" className="natJuridiquecatPesItem">
      {categorie}
      <Divider hidden />
      {natureJuridique}
    </Segment>
  );

  const popupTrigger = (
    <Table.Cell
      selectable
      onClick={() => onClick(categorie, natureJuridique)}
      onDoubleClick={() => {
        onClick(categorie, natureJuridique);
        onDoubleClick();
      }}
      active={activeCell}
    >
      <Icon link name="check circle" />
    </Table.Cell>
  );

  return (
    <Popup key={keyNatureJuridique} trigger={popupTrigger} content={popupContent} />
  );
};

export default NatureJuridiqueCatPesItem;
